import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
//import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import ReCAPTCHA from "react-google-recaptcha";

export default function Home() {
    const navigate = useNavigate();
    const [validCaptcha, setValidCaptcha] = useState(false)
    const [state, setState] = useState(
        {
            first_name:'',
            last_name:'',
            email:'',
            address:'',
            apt: '',
            city:'',
            state:'',
            zip:'',
            privacy:'',
            age: '',
            marketing: '',
            captcha: '',
            interested: ''
        }
    )

    const refFirstName = useRef();
    const refFirstNameError = useRef();
    const refLastName = useRef();
    const refLastNameError = useRef();
    const refEmail = useRef();
    const refEmailError = useRef();
    const refAddress = useRef();
    const refAddressError = useRef();
    const refApt = useRef();
    const refCity = useRef();
    const refCityError = useRef();
    const refState = useRef();
    const refStateError = useRef();
    const refZip = useRef();
    const refZipError = useRef();
    const refPrivacy = useRef();
    const refPrivacyCheck = useRef();
    const refPrivacyError = useRef();
    const refAge = useRef();
    const refAgeCheck = useRef();
    const refAgeError = useRef();
    const refMarketing = useRef();
    const refMarketingCheck = useRef();
    const refInterested = useRef();
    const refInterestedError = useRef();
    const refSubmitError = useRef();
    
    const refErrors = useRef();
    const refCaptchaError = useRef();

    //Overlay References
    const overlay = useRef();
    const loadingOverlay = useRef();
    const popup = useRef();
    const modalHeading = useRef();
    const modalContent = useRef();
    const modalClose = useRef();

    useEffect(() => {
        //loadCaptchaEnginge(6); 
    }, [])

    const handleCaptcha = async () => {
        setValidCaptcha(true)
    }

    const handleExpiredCaptcha = async () => {
        setValidCaptcha(false)
    }

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));

        // Remove error outline from age checkbox 
        if(name === 'age'){
            refAgeCheck.current.classList.remove('error-outline')
        }

        if(name === 'privacy'){
            refPrivacyCheck.current.classList.remove('error-outline')
        }

        // if(name === 'marketing'){
        //     if(refMarketing.current.checked){
        //         if(refInterested.current) refInterested.current.classList.add('show')
        //     }else{
        //         if(refInterested.current) refInterested.current.classList.remove('show')
        //     }
        // }
    }

    // Informational Modal
    function infoModal(heading, content, duration = null){
        // Duration is in ms
        modalHeading.current.innerHTML = heading;
        modalContent.current.innerHTML = content;
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';
        overlay.current.className = 'show';
        popup.current.className = 'show';
        if(duration && duration > 0){
           setTimeout(() => {
             document.body.style.overflow = "auto";
             document.body.style.marginRight = '0';
             overlay.current.className = '';
             popup.current.className = '';
           }, duration)
        }
    }

    // Modal functionality
    function showModal(e){
        e.preventDefault();
        //modalHeading.current.innerHTML = e.target.previousSibling.innerHTML;
        modalHeading.current.innerHTML = e.target.innerHTML;
        modalContent.current.innerHTML = e.target.title.replace(/(?:\r\n|\r|\n)/g, '<p>');
        
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';

        overlay.current.className = 'show';
        popup.current.className = 'show';
    }

    function showLoading(){
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';
        if(loadingOverlay.current) loadingOverlay.current.className = 'show';
    }

    function hideLoading(){
        document.body.style.overflow = "auto";
        document.body.style.marginRight = '0';
        if(loadingOverlay.current) loadingOverlay.current.className = '';
    }

    function closePopup(){
        document.body.style.overflow = "auto";
        document.body.style.marginRight = '0';
        if(overlay.current) overlay.current.className = '';
        if(popup.current) popup.current.className = '';
        //if(popupConfirm.current) popupConfirm.current.className = '';
        //if(refPreview.current) refPreview.current.classList.remove("show");
    }
    // End of Modal Functionality

    // Close popup or admin menu - by clicking anywhere outside of it
    window.onclick = function(event) {
        // Overlay Close
        if (event.target.id == 'overlay') {
        document.body.style.overflow = "auto";
        document.body.style.marginRight = '0';
        const overlay = document.getElementById("overlay")
        const popup = document.getElementById("popup")

        if(overlay) overlay.className = '';
        if(popup) popup.className = '';
        }
    }

    async function handleSubmit(e){
        e.preventDefault();

        let shouldSubmit = true;

        refFirstName.current.classList.remove('error-outline');
        refFirstNameError.current.style.display='none';
        refLastName.current.classList.remove('error-outline');
        refLastNameError.current.style.display='none';
        refEmail.current.classList.remove('error-outline');
        refEmailError.current.style.display='none';
        refAddress.current.classList.remove('error-outline');
        refAddressError.current.style.display='none';
        refCity.current.classList.remove('error-outline');
        refCityError.current.style.display='none';
        refState.current.classList.remove('error-outline');
        refStateError.current.style.display='none';
        refZip.current.classList.remove('error-outline');
        refZipError.current.style.display='none';
        refPrivacyCheck.current.classList.remove('error-outline');
        refPrivacyError.current.style.display='none';
        refAgeCheck.current.classList.remove('error-outline');
        refAgeError.current.style.display='none';
        if(refInterested.current) refInterested.current.classList.remove('error-outline');
        if(refInterestedError.current) refInterestedError.current.style.display='none';
        refCaptchaError.current.style.display='none';
        refSubmitError.current.style.display = 'none';
        refErrors.current.classList.remove('show');
        
        // First Name Validation
        if(state.first_name === ''){
            refFirstName.current.classList.add('error-outline');
            refFirstNameError.current.style.display='block';
            shouldSubmit = false;
        }

        // Last Name Validation
        if(state.last_name === ''){
            refLastName.current.classList.add('error-outline');
            refLastNameError.current.style.display='block';
            shouldSubmit = false;
        }

        // Email Validation - Blank
        if(state.email === ''){
            refEmail.current.classList.add('error-outline');
            refEmailError.current.innerHTML = 'Please enter an email address.';
            refEmailError.current.style.display='block';
            shouldSubmit = false;
        // Email Validation - Correct Format
        }else{
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(!state.email.match(regex)){
                refEmail.current.classList.add('error-outline');
                refEmailError.current.innerHTML = 'Please enter a valid email address.';
                refEmailError.current.style.display='block';
                shouldSubmit = false;
            }
        }

        // Address Validation
        if(state.address === ''){
            refAddress.current.classList.add('error-outline');
            refAddressError.current.style.display='block';
            shouldSubmit = false;
        }

        // City Validation
        if(state.city === ''){
            refCity.current.classList.add('error-outline');
            refCityError.current.style.display='block';
            shouldSubmit = false;
        }

        // State Validation
        if(state.state === '' || state.state.indexOf('Select') !== -1){
            refState.current.classList.add('error-outline');
            refStateError.current.style.display='block';
            shouldSubmit = false;
        }

        // Zip Validation
        if(state.zip === ''){
            refZip.current.classList.add('error-outline');
            refZipError.current.innerHTML = 'Please enter a valid zip code.'
            refZipError.current.style.display='block';
            shouldSubmit = false;
        }
        // else{
        //     if(isNaN(state.zip)){
        //         refZip.current.classList.add('error-outline');
        //         refZipError.current.innerHTML = 'Please enter a valid zip code.'
        //         refZipError.current.style.display='block';
        //         shouldSubmit = false;
        //     }
        // }

        // Privacy Validation
        if(!refPrivacy.current.checked){
            refPrivacyCheck.current.classList.add('error-outline');
            refPrivacyError.current.style.display='block';
            shouldSubmit = false;
        }

        // Age Validation
        if(!refAge.current.checked){
            refAgeCheck.current.classList.add('error-outline');
            refAgeError.current.style.display='block';
            shouldSubmit = false;
        }

        // Marketing Validation
        // if(!refMarketing.current.checked){
        //     refMarketingCheck.current.classList.add('error-outline');
        //     refMarketingError.current.style.display='block';
        //     shouldSubmit = false;
        // }

        // I am interested in... Validation
        if(refMarketing && refMarketing.current.checked){
            if(state.interested === '' || state.interested.indexOf('Select') !== -1){
                refInterested.current.classList.add('error-outline');
                refInterestedError.current.style.display='block';
                shouldSubmit = false;
            }
        }

        // Captcha Validation
        if(!validCaptcha){
            refCaptchaError.current.innerHTML = 'Captcha is not valid.'
            refCaptchaError.current.style.display = 'block';
            shouldSubmit = false;
        }

        if(shouldSubmit){
            // Submit to VeraCore
            showLoading();
            const requestObj = {
                first_name: state.first_name,
                last_name: state.last_name,
                email: state.email,
                address: state.address,
                apt: state.apt,
                city: state.city,
                state: state.state,
                zip: state.zip,
                interested: refInterested.current ? refInterested.current.value : "none"
            }
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestObj)
            };
            
            //const response = await fetch('https://mirumbooks.com/api/order', requestOptions)
            const response = await fetch('https://test-mirumbook.lahlouhonline.com/api/order', requestOptions)
            //const response = await fetch('http://localhost:8080/api/order', requestOptions)

            const data = await response.json()

            if(data.message && data.message === 'success'){
                navigate('/order-submitted');
            }else{
                hideLoading();
                infoModal("Error", "There was an issue submitting your order. Please try again in a few moments.")
                //refSubmitError.current.style.display = 'block';
            }
        }else{
            if(refErrors.current) refErrors.current.classList.add('show');
        }
    }

    return (
        <>
        <main>
            <div className="banner-wrapper">
                <div className="banner">
                    <div className="banner-text-wrapper">
                        <div className="banner-text">
                            MIRUM LIBRARY<br/>
                            <span>GET YOUR COMPLIMENTARY COPY OF <i>FRANKIE FINDS HER VOICE</i></span>
                        </div>
                    </div>
                    <div className="book-girl">
                        <img src="./images/frankie.png" alt="" />
                    </div>
                </div>
            </div>

            <div className="banner-bottom-wrapper">
                <div className="banner-bottom">
                    <div className="banner-bottom-text">
                        <div className="banner-bottom-header">A book inspired by and created for the cholestatic liver disease community.</div>
                        <div className="banner-bottom-body-text">
                            People and community are at the heart of what we do at Mirum. Inspired by the remarkable and resilient families we've gotten to know over the years, we've created a story meant to celebrate them and to communicate a simple message to the cholestatic liver disease community: you're not alone.
                        </div>
                    </div>
                </div>
                <div className="curved-container">
                    <svg width="100%" height="150" viewBox="0 0 500 80" preserveAspectRatio="none">
                        <path d="M0,0 L0,40 Q250,80 500,40 L500,0 Z" fill="#f4f6f7" />
                    </svg>
                </div>
            </div>

            <div className="main">
                <div className="main-content">
                    <div className="left-content">
                        <div className="product-wrapper">
                            <div className="product-image">
                                <img src="./images/frankie-book.png" alt="Frankie Finds Her Voice"  />
                            </div>

                            <div className="product-title">
                                <i>Frankie Finds Her Voice</i>
                            </div>
                        </div>
                        
                        <div className="product-bottom-text">
                            Frankie is no ordinary fifth grader. She's brave and bold, even when cholestatic liver disease gets in the way of her everyday life. But today, Frankie's determined to live life on her terms. Follow her journey through one extraordinary day where she discovers that no matter the challenge, she's always in charge of her own story.
                        </div>
                    </div>

                    <form name="mirum-form" onSubmit={handleSubmit} autoComplete="on">
                    <div className="form-content">
                        <h1>Book Order Form</h1>
                        <div className="mt10">
                            Complete this short form to receive a complimentary copy of our book for patients and families living with cholestatic liver disease.
                        </div>

                        <div className="mt15">
                            <span className="gray-text">
                                Quantity: 1
                            </span>
                        </div>

                        <div className="mt10">
                            If you are interested in ordering multiple copies, please contact <a href="mailto:MirumChildrensBookOnline@Lahlouh.com?subject=Mirum Children's Book" title="Email Us">MirumChildrensBookOnline@Lahlouh.com</a>
                        </div>

                        <div className="mt30">
                            <span className="required"></span><span className="red-text">Indicates a required field.</span>
                        </div>
                    
                        <div className="element-wrapper mt20">
                            <div className="element">
                                <label htmlFor="first_name" className="required">First Name</label>
                                <input
                                    id="first_name"
                                    name="first_name"
                                    ref={refFirstName}
                                    type="text"
                                    value={state.first_name}
                                    // placeholder="First Name"
                                    onChange={handleChange}
                                    required={true}
                                    autoComplete="given-name"
                                />

                                <div ref={refFirstNameError} className="errorMessage">
                                    Please enter your first name.
                                </div>
                            </div>

                            <div className="element">
                                <label htmlFor="last_name" className="required">Last Name</label>
                                <input
                                    id="last_name"
                                    name="last_name"
                                    ref={refLastName}
                                    type="text"
                                    value={state.last_name}
                                    onChange={handleChange}
                                    required={true}
                                    autoComplete="family-name"
                                />

                                <div ref={refLastNameError} className="errorMessage">
                                    Please enter your last name.
                                </div>
                            </div>
                        </div>

                        <div className="element mt20">
                            <label htmlFor="email" className="required">Email Address <span style={{color:'#5a5a5a',fontWeight:'normal'}}>(name@example.com)</span></label>
                            <input
                                id="email"
                                name="email"
                                ref={refEmail}
                                type="email"
                                onChange={handleChange}
                                required={true}
                                autoComplete="email"
                            />

                            <div ref={refEmailError} className="errorMessage">
                                Please enter an email address.
                            </div>
                        </div>

                        <div className="element mt20">
                            <label htmlFor="address" className="required">Street Address</label>
                            <input
                                id="address"
                                name="address"
                                ref={refAddress}
                                type="text"
                                onChange={handleChange}
                                required={true}
                                autoComplete="address-line1"
                            />

                            <div ref={refAddressError} className="errorMessage">
                                Please enter a street address.
                            </div>
                        </div>

                        <div className="element-wrapper mt20">
                            <div className="element">
                                <label htmlFor="apt">Apt/Suite/Unit (optional)</label>
                                <input
                                    id="apt"
                                    name="apt"
                                    ref={refApt}
                                    type="text"
                                    onChange={handleChange}
                                    autoComplete="address-line2"
                                />

                                <div ref={refCityError} className="errorMessage">
                                    Please enter a city name.
                                </div>
                            </div>
                            
                            <div className="element">
                                <label htmlFor="city" className="required">City</label>
                                <input
                                    id="city"
                                    name="city"
                                    ref={refCity}
                                    type="text"
                                    onChange={handleChange}
                                    required={true}
                                    autoComplete="address-level2"
                                />

                                <div ref={refCityError} className="errorMessage">
                                    Please enter a city.
                                </div>
                            </div>
                        </div>

                        <div className="element-wrapper mt20">
                            <div className="element">
                                <label htmlFor="state" className="required">State</label>
                                <select
                                    id="state"
                                    name="state"
                                    ref={refState}
                                    value={state.state}
                                    onChange={handleChange}
                                    required={true}
                                    autoComplete="address-level1"
                                >
                                    <option>Select a state...</option>
                                    <option value="Alabama">Alabama</option>
                                    <option value="Alaska">Alaska</option>
                                    <option value="Arizona">Arizona</option>
                                    <option value="Arkansas">Arkansas</option>
                                    <option value="California">California</option>
                                    <option value="Colorado">Colorado</option>
                                    <option value="Connecticut">Connecticut</option>
                                    <option value="Delaware">Delaware</option>
                                    <option value="District of Colombia">District of Colombia</option>
                                    <option value="Florida">Florida</option>
                                    <option value="Georgia">Georgia</option>
                                    <option value="Hawaii">Hawaii</option>
                                    <option value="Idaho">Idaho</option>
                                    <option value="Illinois">Illinois</option>
                                    <option value="Indiana">Indiana</option>
                                    <option value="Iowa">Iowa</option>
                                    <option value="Kansas">Kansas</option>
                                    <option value="Kentucky">Kentucky</option>
                                    <option value="Louisiana">Louisiana</option>
                                    <option value="Maine">Maine</option>
                                    <option value="Maryland">Maryland</option>
                                    <option value="Massachusetts">Massachusetts</option>
                                    <option value="Michigan">Michigan</option>
                                    <option value="Minnesota">Minnesota</option>
                                    <option value="Mississippi">Mississippi</option>
                                    <option value="Missouri">Missouri</option>
                                    <option value="Montana">Montana</option>
                                    <option value="Nebraska">Nebraska</option>
                                    <option value="Nevada">Nevada</option>
                                    <option value="New Hampshire">New Hampshire</option>
                                    <option value="New Jersey">New Jersey</option>
                                    <option value="New Mexico">New Mexico</option>
                                    <option value="New York">New York</option>
                                    <option value="North Carolina">North Carolina</option>
                                    <option value="North Dakota">North Dakota</option>
                                    <option value="Ohio">Ohio</option>
                                    <option value="Oklahoma">Oklahoma</option>
                                    <option value="Oregon">Oregon</option>
                                    <option value="Pennsylvania">Pennsylvania</option>
                                    <option value="Rhode Island">Rhode Island</option>
                                    <option value="South Carolina">South Carolina</option>
                                    <option value="South Dakota">South Dakota</option>
                                    <option value="Tennessee">Tennessee</option>
                                    <option value="Texas">Texas</option>
                                    <option value="Utah">Utah</option>
                                    <option value="Vermont">Vermont</option>
                                    <option value="Virginia">Virginia</option>
                                    <option value="Washington">Washington</option>
                                    <option value="West Virginia">West Virginia</option>
                                    <option value="Wisconsin">Wisconsin</option>
                                    <option value="Wyoming">Wyoming</option>
                                </select>

                                <div ref={refStateError} className="errorMessage">
                                    Please select a state.
                                </div>
                            </div>

                            <div className="element">
                                <label htmlFor="zip" className="required">Zip Code</label>
                                <input
                                    id="zip"
                                    name="zip"
                                    ref={refZip}
                                    type="text"
                                    maxLength="5"
                                    onChange={handleChange}
                                    required={true}
                                    autoComplete="postal-code"
                                />

                                <div ref={refZipError} className="errorMessage" />
                            </div>
                        </div>

                        <div className="element mt15 padLeft8">
                            <a className="black-link" href="https://mirumpharma.com/privacy-policy/" target="_blank" title="View Privacy Policy">View Privacy Policy</a><span className="required"/>
                        </div>

                        {/* Privacy Policy Accept */}
                        <div className="element mt15">
                            <div className="radio-check-wrapper">
                                <label id="privacy" className="required checkbox-container no-highlight">
                                    <input 
                                        ref={refPrivacy}
                                        type="checkbox"
                                        name="privacy"
                                        id="privacy"
                                        value={state.privacy}
                                        // checked={state.age && state.age === 'Y'}
                                        onChange={handleChange}
                                        required={true}
                                    />
                                    <span ref={refPrivacyCheck} className="checkmark"></span>
                                    I have read the Mirum Privacy Policy.
                                </label>
                            </div>

                            <div ref={refPrivacyError} className="errorMessage nmt10">
                                You must check this box to confirm you have read the privacy policy.
                            </div>
                        </div>

                        {/* Age Consent */}
                        <div className="element mt10">
                            <div className="radio-check-wrapper">
                                <label id="age" className=" required checkbox-container no-highlight">
                                    <input 
                                        ref={refAge}
                                        type="checkbox"
                                        name="age"
                                        id="age"
                                        value={state.age}
                                        // checked={state.age && state.age === 'Y'}
                                        onChange={handleChange}
                                        required={true}
                                    />
                                    <span ref={refAgeCheck} className="checkmark"></span>
                                    I certify that I am over 13 year old.
                                </label>
                            </div>

                            <div ref={refAgeError} className="errorMessage nmt10">
                                You must check this box to confirm you are over 13 years old.
                            </div>
                        </div>

                        {/* Marketing Opt-in */}
                        <div className="element mt10">
                            <div className="radio-check-wrapper">
                                <label htmlFor="marketing" className="checkbox-container no-highlight">
                                    <input 
                                        ref={refMarketing}
                                        type="checkbox"
                                        id="marketing"
                                        name="marketing"
                                        value={state.marketing}
                                        onChange={handleChange}
                                    />
                                    <span className="checkmark"></span>
                                    <span className="marketing-text">By checking this box, I give Mirum and companies working at Mirum's direction permission to use my contact information to provide promotional information to me about Mirum products, services, programs, or other topics that Mirum thinks may interest me. I understand that Mirum will use and share my information in accordance with the Privacy Notice on the Mirum website.</span>
                                </label>
                            </div>

                            {/* <div ref={refMarketingError} className="errorMessage nmt10">
                                This selection is required
                            </div> */}
                        </div>

                        {/* I am interested in... */}
                        {refMarketing.current && refMarketing.current.checked && 
                        <div 
                            className={refMarketing.current && refMarketing.current.checked ? "element interested-wrapper mt10 show" : "element interested-wrapper mt10"}
                        >
                            <label htmlFor="interested" className="required">I am interested in</label>
                            <select
                                id="interested"
                                name="interested"
                                ref={refInterested}
                                value={state.interested}
                                onChange={handleChange}
                                required={true}
                            >
                                <option>Select an option...</option>
                                <option value="ALGS">Alagille syndrome</option>
                                <option value="PFIC">Progressive familial intrahepatic cholestasis (PFIC)</option>
                            </select>

                            <div ref={refInterestedError} className="errorMessage">
                                Please select an option.
                            </div>
                        </div>
                        }
                        

                        {/* ReCAPTCHA */}
                        <div className="mt15">
                            <div aria-label="Checkbox to validate you're not a robot">To continue, click the checkbox below: <span className="required"/></div>
                            <div className="mt10">
                                <ReCAPTCHA
                                    sitekey="6LctRvkrAAAAAA_L100RcUN3k8QDlacjWvPJ5wwj"
                                    size="normal"
                                    onChange={handleCaptcha}
                                    onExpired={handleExpiredCaptcha}
                                />
                            </div>

                            <div ref={refCaptchaError} className="errorMessage" />
                        </div>
                        
                        <div className="form-message mt15">
                            By completing this form, you agree to our <a href="https://mirumpharma.com/terms-of-use/" target="_blank" title="Terms of Use">Terms of Use</a> and <a href="https://mirumpharma.com/privacy-policy/" target="_blank" title="Privacy Policy">Privacy Policy</a>.
                        </div>
                        
                        <div ref={refErrors} className="small-width errorMaster center">
                            Required inputs are missing or contain incorrect information. Please correct the highlighted fields before submitting.
                        </div>
                    
                        {/* Submit Button */}
                        <div className="mt30">
                            <input
                                type="submit"
                                className="primary-button" 
                                onClick={handleSubmit}
                                aria-label="Submit Book Order"
                                value="Submit"
                            />
                            
                        </div>

                        <div className="mt20 errorMessage" ref={refSubmitError}>
                            There was an error submitting the form. Please try again in a few moments.
                        </div>
                    </div>
                    </form>

                    <div className="div-divider" />

                    <div className="center">
                        Domestic US shipping only.
                    </div>
                </div>
            </div>
            
            <div id="overlay" ref={overlay}></div>

            <div id="loading-overlay" ref={loadingOverlay}>
                <div className="deadCenter">
                    <div className="lds-spinner">
                        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                    </div>
                </div>
            </div>

            <div id="popup" ref={popup}>
                <div id="modal-heading" className="center" ref={modalHeading}></div>
                <span id="popup-close" ref={modalClose} className="close" onClick={closePopup}>&times;</span>
                <div id="modal-content" ref={modalContent} className="content center"></div>
            </div>
        </main>
        </>

    )
}
